export const dataTestId = 'data-testid';
export const baseCodeEditorContentTestId = 'base-code-editor-content';
export const baseCodeEditorTestId = 'base-code-editor';
export const baseCodeEditorRootTestId = 'base-code-editor-root';
export const baseCodeEditorScrollerTestId = 'base-code-editor-scroller';
